import BaseModel from "./BaseModel";

// To avoid name collision with Tag in antd, this model is named
// TagModel instead of Tag.

class TagModel extends BaseModel {
  tag: string;
  accountIds: number[];
  constructor(data) {
    super(data, []);
    this.tag = data.tag;
    this.accountIds = data.accountIds;
  }
}

export default TagModel;
